import {
  withTranslation,
} from 'react-i18next';

import ChampionshipRegattaFieldsView from './ChampionshipRegattaFieldsView';

const TranslatedComponent = withTranslation()(ChampionshipRegattaFieldsView);

const Component = TranslatedComponent;

export default Component;
